import { useState, useEffect } from 'react';
import './Hero.css';

const WORDS = ['clean APIs.', 'scalable SPAs.', 'CI/CD pipelines.', 'shipped products.', 'AI-powered apps.'];

export default function Hero() {
  const [displayed, setDisplayed] = useState('');
  const [wordIndex, setWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const word = WORDS[wordIndex];
    const timeout = setTimeout(() => {
      if (!deleting) {
        setDisplayed(word.slice(0, charIndex + 1));
        if (charIndex + 1 === word.length) {
          setTimeout(() => setDeleting(true), 1400);
        } else {
          setCharIndex(c => c + 1);
        }
      } else {
        setDisplayed(word.slice(0, charIndex - 1));
        if (charIndex - 1 === 0) {
          setDeleting(false);
          setWordIndex(i => (i + 1) % WORDS.length);
          setCharIndex(0);
        } else {
          setCharIndex(c => c - 1);
        }
      }
    }, deleting ? 45 : 72);
    return () => clearTimeout(timeout);
  }, [charIndex, deleting, wordIndex]);

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="hero" className="hero-section section-wrap">
      <div className="orb1" /><div className="orb2" />

      <div className="hero-status-row">
        <div className="avail-pill">
          <div className="avail-dot" /><span className="avail-txt">Available for opportunities</span>
        </div>
        <a
          className="cert-badge"
          href="https://www.credly.com/badges/9e3017f6-2afd-4772-b05e-22130be8f625/public_url"
          target="_blank"
          rel="noopener noreferrer"
          title="Verify on Credly"
        >
          <i className="ti ti-certificate" /><span>Claude Certified Developer · Foundations</span>
        </a>
      </div>

      <div className="hero-eyebrow">Senior Full-Stack Developer · Madurai, India</div>
      <h1 className="hero-name">C. <span>Vikram</span> Raja</h1>
      <div className="hero-role">.NET &nbsp;·&nbsp; Angular &nbsp;·&nbsp; Azure &nbsp;·&nbsp; AI-Driven Development</div>

      <div className="typewriter-row">
        <span className="tw-prefix">Turning complex requirements into</span>
        <span className="tw-word">{displayed}</span>
        <span className="tw-cursor" />
      </div>

      <div className="pills-row">
        {[
          { label: '8+ Years', hi: true },
          { label: 'Enterprise Scale', hi: true },
          // { label: 'UK Clients', hi: false },
          { label: 'AI-Assisted Dev', hi: false },
          { label: 'CI/CD Pipelines', hi: false },
          { label: 'Microservices', hi: false },
        ].map(p => (
          <span key={p.label} className={`pill ${p.hi ? 'hi' : ''}`}>{p.label}</span>
        ))}
      </div>

      <p className="hero-desc">
        Building robust, scalable enterprise web applications — from RESTful .NET APIs and Angular SPAs to Azure CI/CD pipelines. Currently shipping AI-assisted products using Cursor IDE, MCP, and vibe coding workflows.
      </p>

      <div className="badge-row">
        {['ASP.NET Core','Angular 21','Azure','Supabase','Cursor IDE','MCP','SQL Server','Microservices'].map(b => (
          <span key={b} className="tag">{b}</span>
        ))}
      </div>

      <div className="cta-row">
        <button className="btn-primary" onClick={() => scrollTo('projects')}>View Projects</button>
        <button className="btn-outline" onClick={() => scrollTo('contact')}>
          <i className="ti ti-mail" /> Contact
        </button>
        <button className="btn-outline">
          <i className="ti ti-download" /> Download CV
        </button>
      </div>

      <div className="stats-bar">
        {[
          { num: '8+', label: 'Years exp.' },
          { num: '6',  label: 'Projects' },
          { num: '3',  label: 'Enterprise clients' },
          { num: '15+',label: 'Tech stacks' },
        ].map(s => (
          <div key={s.label} className="stat-item">
            <div className="stat-num">{s.num}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="scroll-hint">
        <div className="scroll-line" />
        <span className="scroll-txt">Scroll to explore</span>
        <div className="scroll-line" />
      </div>
    </section>
  );
}
